export default __webpack_public_path__ + "static/media/werewolfnovels.ee6824d4.png";